import { Channel } from 'types/channels';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { ScrollableList } from 'components/DesignSystems/ScrollableList';
import { MdLock, MdStar } from 'react-icons/md';

interface ChannelListProps {
  channels: Channel[];
  onEdit: (channelName: string) => void;
  onRemove: (channelName: string) => void;
  onAdd: () => void;
}

export function ChannelList({
  channels,
  onEdit,
  onRemove,
  onAdd,
}: ChannelListProps) {
  return (
    <div>
      <div className="mb-4">
        <StylishNewButton className="button--secondary" onClick={onAdd}>
          Add
        </StylishNewButton>
      </div>
      <ScrollableList>
        {channels.map((channel) => (
          <ChannelItem
            key={channel.displayName}
            channel={channel}
            onEdit={() => onEdit(channel.displayName)}
            onRemove={() => onRemove(channel.displayName)}
          />
        ))}
      </ScrollableList>
    </div>
  );
}

interface ChannelItemProps {
  channel: Channel;
  onEdit: () => void;
  onRemove: () => void;
}

function ChannelItem({ channel, onEdit, onRemove }: ChannelItemProps) {
  return (
    <div className="d-flex justify-content-between p-3 mb-2 rounded bg-neutral-800">
      <div className="d-flex flex-column">
        <div className="d-flex align-items-center">
          <span className="fs-5 fw-medium">{channel.displayName}</span>
          <div className="d-flex align-items-center ms-1">
            {channel.membershipType === 'private' && (
              <span className="d-flex align-items-center justify-content-center text-muted">
                <MdLock size={18} />
              </span>
            )}
            {channel.isFavoriteByDefault && (
              <span className="d-flex align-items-center justify-content-center text-muted">
                <MdStar size={18} />
              </span>
            )}
          </div>
        </div>
        {channel.description && (
          <div className="text-muted small">{channel.description}</div>
        )}
      </div>
      <div className="d-flex gap-2">
        <StylishNewButton className="button--primary" onClick={onEdit}>
          Edit
        </StylishNewButton>
        <StylishNewButton className="button--secondary" onClick={onRemove}>
          Delete
        </StylishNewButton>
      </div>
    </div>
  );
}
